import apiConfig from "../../apiConfig";

export const getDonationBandsList = async (at) => {
	const response = await apiConfig.post(
		"/API/CHARITY/LOOKUPS/DONATIONS_BANDS/Get_Donations_Bands_List",
		{},
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	return response;
};
